import { Box, Container, Divider, IconButton, Typography } from "@mui/material";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import {
  FaClock,
  FaEnvelope,
  FaInstagram,
  FaMapMarkerAlt,
  FaPhoneAlt
} from "react-icons/fa";

import { Link } from "react-router-dom";
import footerBg from "../../assets/images/footer_bg.png";
import footer_bg_m from "../../assets/images/footer_bg_m.png";
import logo from "../../assets/logos/logo-whtie.png";

const services = [
  { title: "Dry Cleaning", path: "/services" },

  // { title: "Laundry Service", path: "/services/laundry-service" },

  { title: "Alterations & Repairs", path: "/services" },

  { title: "Wedding Dress Care", path: "/services" },

  { title: "Shoe Cleaning & Repair", path: "/services" },

  // { title: "Handbag Cleaning", path: "/services/handbag-cleaning" },

  { title: "Custom Printing", path: "/services" },

  // { title: "Rug Cleaning", path: "/services/rug-cleaning" },

  // { title: "Comforter Cleaning", path: "/services/comforter-cleaning" },

  // { title: "Cushion Cleaning", path: "/services/cushion-cleaning" },

  // { title: "Steam Pressing", path: "/services/steam-pressing" },
];

const companyLinks = [
  { title: "About Us", path: "/about" },

  { title: "Services", path: "/services" },

  { title: "Pricing", path: "/pricing" },

  { title: "Contact Us", path: "/contact" },

  // { title: "Privacy Policy", path: "/privacy-policy" },

  // { title: "Terms & Conditions", path: "/terms-conditions" },
];

const areas = ["Ajax", "Pickering", "Whitby", "Surrounding Areas"];

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        position: "relative",

        overflow: "hidden",

        backgroundImage: { xs: `url(${footer_bg_m})`, md: `url(${footerBg})` },

        backgroundSize: "cover",

        backgroundPosition: "center",

        backgroundRepeat: "no-repeat",

        "&::before": {
          content: '""',

          position: "absolute",

          inset: 0,

          background: `
          linear-gradient(
          135deg,
          rgba(0,87,255,.40) 0%,
          rgba(0,45,135,.50) 40%,
          rgba(7,18,47,.60) 100%
          )
          `,

          zIndex: 1,
        },
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          position: "relative",
          zIndex: 2,
        }}
      >
        <Box
          sx={{
            py: {
              xs: 6,
              md: 8,
            },
          }}
        >
          <Box
            sx={{
              display: "flex",

              flexDirection: {
                xs: "column",
                lg: "row",
              },

              justifyContent: "space-between",

              gap: {
                xs: 5,
                lg: 8,
              },
            }}
          >
            {/* LEFT SIDE */}
            <Box
              sx={{
                width: {
                  xs: "100%",
                  lg: "34%",
                },
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="Comet Cleaners"
                sx={{
                  width: {
                    xs: 180,
                    md: 240,
                  },

                  height: "auto",

                  objectFit: "contain",

                  display: "block",

                  mb: 3,
                }}
              />

              <Typography
                sx={{
                  color: "rgba(255,255,255,.90)",

                  lineHeight: 1.9,

                  maxWidth: "470px",

                  fontSize: {
                    xs: "14px",
                    md: "15px",
                  },
                }}
              >
                Your trusted destination for cleaning, repairs, custom printing
                and specialty care services with convenient pickup & delivery
                throughout Ajax and surrounding communities.
              </Typography>

              <Box
                sx={{
                  display: "flex",

                  gap: 1.5,

                  mt: 3,
                }}
              >
                {[
                  // <FaWhatsapp />,
                  <FaInstagram />,
                  // <FaFacebookF />,
                  // <FaLinkedinIn />,
                ].map((icon, index) => (
                  <IconButton
                    href="https://www.instagram.com/cometcleaners.ca?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                    target="_blank"
                    key={index}
                    sx={{
                      width: 54,

                      height: 54,

                      color: "#fff",

                      background: "rgba(255,255,255,.08)",

                      border: "1px solid rgba(255,255,255,.12)",

                      backdropFilter: "blur(18px)",

                      transition: ".3s",

                      "&:hover": {
                        background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                        transform: "translateY(-4px)",
                      },
                    }}
                  >
                    {icon}
                  </IconButton>
                ))}
              </Box>
            </Box>
            {/* CENTER LINKS */}
            <Box
              sx={{
                display: "flex",

                gap: {
                  xs: 6,
                  md: 10,
                },

                flexWrap: "wrap",

                width: {
                  xs: "100%",
                  lg: "36%",
                },
              }}
            >
              <Box>
                <Typography
                  sx={{
                    color: "#fff",

                    fontWeight: 800,

                    mb: 3,

                    fontSize: "20px",
                  }}
                >
                  Services
                </Typography>

                {services.map((item) => (
                  <Link
                    key={item.title}
                    to={item.path}
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",

                        alignItems: "center",

                        gap: 1,

                        mb: 2,

                        cursor: "pointer",

                        color: "rgba(255,255,255,.75)",

                        transition: ".3s",

                        "&:hover": {
                          color: "#1DB6FF",

                          pl: 1,
                        },
                      }}
                    >
                      <ArrowForwardIosIcon
                        sx={{
                          fontSize: 11,
                        }}
                      />

                      <Typography
                        fontSize={14}
                        sx={{
                          color: "rgba(255,255,255,.75)",

                          transition: ".3s",

                          "&:hover": {
                            color: "#1DB6FF",
                          },
                        }}
                      >
                        {item.title}
                      </Typography>
                    </Box>
                  </Link>
                ))}
              </Box>

              <Box>
                <Typography
                  sx={{
                    color: "#fff",

                    fontWeight: 800,

                    mb: 3,

                    fontSize: "20px",
                  }}
                >
                  Company
                </Typography>

                {companyLinks.map((item) => (
                  <Link
                    key={item.title}
                    to={item.path}
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",

                        alignItems: "center",

                        gap: 1,

                        mb: 2,

                        cursor: "pointer",

                        color: "rgba(255,255,255,.75)",

                        transition: ".3s",

                        "&:hover": {
                          color: "#1DB6FF",

                          pl: 1,
                        },
                      }}
                    >
                      <ArrowForwardIosIcon
                        sx={{
                          fontSize: 11,
                        }}
                      />

                      <Typography
                        fontSize={14}
                        sx={{
                          color: "rgba(255,255,255,.75)",

                          transition: ".3s",

                          "&:hover": {
                            color: "#1DB6FF",
                          },
                        }}
                      >
                        {item.title}
                      </Typography>
                    </Box>
                  </Link>
                ))}
              </Box>
            </Box>{" "}
            {/* CONTACT CARD */}
            <Box
              sx={{
                width: {
                  xs: "100%",
                  lg: "360px",
                },

                p: 3,

                borderRadius: "24px",

                background: "rgba(255,255,255,.06)",

                border: "1px solid rgba(255,255,255,.12)",

                backdropFilter: "blur(22px)",

                boxShadow: "0 20px 50px rgba(0,87,255,.18)",
              }}
            >
              <Typography
                sx={{
                  color: "#fff",

                  fontWeight: 800,

                  mb: 3,

                  fontSize: "22px",
                }}
              >
                Contact Information
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2.5,
                }}
              >
                <Box sx={{ display: "flex", gap: 2 }}>
                  <FaPhoneAlt color="#1DB6FF" />

                  <Link
                    href="tel:+19054283542"
                    underline="none"
                    sx={{
                      color: "#fff",
                      fontWeight: 600,
                      textDecoration: "none",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#DCE7FF",
                      }}
                    >
                      +19054283542
                    </Typography>
                  </Link>
                </Box>

                <Box sx={{ display: "flex", gap: 2, color: "#fff !important" }}>
                  <FaEnvelope color="#1DB6FF" />

                  <Link
                    href="mailto:cometcleaners5@gmail.com"
                    underline="none"
                    color="#fff"
                    sx={{
                      color: "#fff !important",
                      fontWeight: 600,
                      textDecoration: "none",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#DCE7FF",
                      }}
                    >
                      cometcleaners5@gmail.com
                    </Typography>
                  </Link>
                </Box>

                <Box sx={{ display: "flex", gap: 2 }}>
                  <FaMapMarkerAlt color="#1DB6FF" />

                  <Typography
                    sx={{
                      color: "#DCE7FF",
                    }}
                  >
                    15 Westney Rd N, Unit 4A, Ajax, ON L1T 1P5
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
                  <FaClock color="#1DB6FF" size={20} />

                  <Typography
                    sx={{
                      color: "#DCE7FF",
                      lineHeight: 1.8,
                      fontSize: {
                        xs: "15px",
                        md: "18px",
                      },
                      fontWeight: 500,
                    }}
                  >
                    <strong>Monday - Friday</strong>
                    <br />
                    08:30 AM - 06:30 PM
                    <br />
                    <strong>Saturday</strong>
                    <br />
                    09:00 AM - 05:00 PM
                    <br />
                    <strong>Sunday</strong>
                    <br />
                    Closed
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>

          <Divider
            sx={{
              my: 5,
              borderColor: "rgba(255,255,255,.08)",
            }}
          />

          {/* SERVICE AREAS */}

          <Typography
            sx={{
              color: "#fff",

              fontWeight: 800,

              mb: 2,

              fontSize: "20px",
            }}
          >
            Service Areas
          </Typography>

          <Box
            sx={{
              display: "flex",

              flexWrap: "wrap",

              gap: 1.2,
            }}
          >
            {areas.map((area) => (
              <Box
                key={area}
                sx={{
                  px: 2.5,

                  py: 1,

                  borderRadius: "50px",

                  background: "rgba(255,255,255,.08)",

                  border: "1px solid rgba(255,255,255,.10)",

                  color: "#fff",

                  fontWeight: 700,

                  fontSize: "13px",

                  transition: ".3s",

                  cursor: "pointer",

                  "&:hover": {
                    background: "linear-gradient(135deg,#0057FF,#1DB6FF)",
                  },
                }}
              >
                {area}
              </Box>
            ))}
          </Box>

          {/* COPYRIGHT */}

          <Box
            sx={{
              mt: 5,

              pt: 3,

              borderTop: "1px solid rgba(255,255,255,.08)",

              display: "flex",

              flexDirection: {
                xs: "column",
                md: "row",
              },

              justifyContent: "space-between",

              alignItems: "center",

              gap: 2,
            }}
          >
            <Typography
              sx={{
                color: "rgba(255,255,255,.70)",

                fontSize: "14px",
              }}
            >
              © 2026 Comet Cleaners. All Rights Reserved.
            </Typography>

            <Box
              sx={{
                display: "flex",
                gap: 3,
              }}
            >
              <Link
                sx={{ color: "inherit", textDecoration: "none" }}
                to="/privacy-policy"
              >
                <Typography
                  sx={{
                    color: "rgba(255,255,255,.70)",

                    cursor: "pointer",
                  }}
                >
                  Privacy Policy
                </Typography>
              </Link>

              <Link
                sx={{ color: "inherit", textDecoration: "none" }}
                to="/terms-conditions"
              >
                <Typography
                  sx={{
                    color: "rgba(255,255,255,.70)",

                    cursor: "pointer",
                  }}
                >
                  Terms & Conditions
                </Typography>
              </Link>
            </Box>
          </Box>
        </Box>
      </Container>
      <Typography
        sx={{
          fontSize: "12px",
          color: "#7B8BA7",
          mt: 3,
          textAlign: "center",
          display: "none",
        }}
      >
        Comet Cleaners provides professional dry cleaning, laundry service,
        wedding dress cleaning, alterations, rug cleaning, shoe repair, handbag
        cleaning and pickup & delivery services across Ajax, Pickering and
        Whitby.
      </Typography>
    </Box>
  );
}
